//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'underscore'
// import DIC from '@/index/dictionary'

export default {
  props: {
    visible: {
      default: false
    },
    initialForm: {
      default: () => ({})
    }
  },
  data: function () {
    return {
      currentVisible: this.visible,
      loading: false,
      info: {}
    }
  },
  watch: {
    visible: {
      handler (val) {
        this.currentVisible = val
      },
      immediate: true
    }
  },
  methods: {
    handleLoadData () {
      let data = _.pick(this.initialForm, 'pOrderId')
      this.loading = true
      this.$axios.get('/mtea/store/admin/purchase/pick/info', { params: data }).then(res => {
        _.each(res.dealers, (t, i, l) => {
          if (t.locationExtra) {
            l[i].locationExtra = JSON.parse(t.locationExtra)
          }
        })
        this.info = res
      }).finally(() => {
        this.loading = false
      })
    },
    handleOpen () {
      this.handleLoadData()
    },
    handleClose(){
      _.extend(this, _.pick(this.$options.data(), 'info'))
    }
  }
}
